__turbopack_context__.v({
  "body": "TalesFanStoryCard-module-scss-module__8TLUra__body",
  "copy": "TalesFanStoryCard-module-scss-module__8TLUra__copy",
  "display": "TalesFanStoryCard-module-scss-module__8TLUra__display",
  "fade-in": "TalesFanStoryCard-module-scss-module__8TLUra__fade-in",
  "image": "TalesFanStoryCard-module-scss-module__8TLUra__image",
  "isInView": "TalesFanStoryCard-module-scss-module__8TLUra__isInView",
  "label": "TalesFanStoryCard-module-scss-module__8TLUra__label",
  "media": "TalesFanStoryCard-module-scss-module__8TLUra__media",
  "product": "TalesFanStoryCard-module-scss-module__8TLUra__product",
  "root": "TalesFanStoryCard-module-scss-module__8TLUra__root",
});
